import { Module } from 'vuex';
import { IRootState } from '@signing-page/store/store';
import { actions } from '@/editor/editor-block-view/store/editor-view.actions';

export const editorView: Module<{}, IRootState> = {
  actions,
  namespaced: true,
};
